
import BgLanding from './BgLanding.js'

export default {

    data()
    {
        return {

            // - 0: created
            // - 1: start load img
            // - 2: img loaded + 4 sec
            // - 3: start bg 3d
            // - +20sec -> next page
            state: 0
        }
    },

    props: {
    	content: Object
    },

    created()
    {
        this._loginTime = 4000
        this._introTime = 14000

        this.onResize = this.onResize.bind(this)
        this.enterFrame = this.enterFrame.bind(this)

        this.eventHub.$on('window:resized', this.onResize)
        this.eventHub.$on('enterFrame', this.enterFrame)
    },

    mounted()
    {
        const target = this.$el.querySelector('#landing-webgl-bg')
        const [width, height] = this.$root.$children[0].windowSize

        const bg = new BgLanding( target, width, height, this.$root.$children[0].support.touch, this.onBgLoaded.bind(this) )
        this._bg = bg

        this.state = 1
        this.eventHub.$emit('page:loaded', this)

        setTimeout(() => {
            if (++this.state > 2)
            {
                this._start3D()
            }
        }, this._loginTime)
    },

    destroyed()
    {
        if (this._bg)
        {
            this._bg.dispose()
        }

        this.eventHub.$off('window:resized', this.onResize)
        this.eventHub.$off('enterFrame', this.enterFrame)
        this.$el.classList.remove('is-leaving')
    },

    methods: {

        onResize( w, h )
        {
            if (this._bg) {
                this._bg.resize(w, h)
            }
        },

        enterFrame( dt )
        {
            if (this._bg) {
                this._bg.update(dt)
            }
        },

        onBgLoaded()
        {
            if (++this.state > 2)
            {
                this._start3D()
            }
        },

        _start3D()
        {
            setTimeout(() => {
                this.state += 0.1
            }, 5100)

            this._bg.start(this._introTime, this._leave.bind(this))
        },

        _leave()
        {
            this._bg.leave()
            this.$el.classList.add('is-leaving')

            setTimeout(() => {
                this.$root.$children[0].loadPage({path:'/home'})
            }, 1630)
        }
    }

}
